import Vue from 'vue';
import VueRouter from 'vue-router';
import EventBus from '@/utils/eventBus';
import store from '@/utils/store';
import jsBridge from '@/assets/js/doudouJSBridge';
Vue.use(VueRouter);

const routes = [
  {
    path: '/loanContract/:token?/:signOrderId?',
    name: 'loanContract',
    component: () => import('../pages/moneyLenderList.vue'),
    meta: {
      title: '合同列表',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
    // children: [
    //   {
    //     path: 'list',
    //     name: 'list',
    //     component: () => import('../pages/list.vue'),
    //   },
    // ],
  },
  {
    path: '/channelMoneyLenderList',
    name: 'channelMoneyLenderList',
    component: () => import('../pages/channelMoneyLenderList.vue'),
    meta: {
      title: '合同列表',
      pageSource: 'channel',
    },
  },
  {
    path: '/doudou/moneyLenderList', // 豆豆对接导流平台
    name: 'doudouMoneyLenderList',
    component: () => import('../pages/channelMoneyLenderList.vue'),
    meta: {
      title: '合同列表',
      pageSource: 'doudou',
    },
  },
  {
    path: '/privacyManage',
    name: 'privacyManage',
    component: () => import('../../../pages/privacyManage.vue'),
    meta: {
      voiceAuth: '允许访问麦克风',
      photoAuth: '允许访问相册',
      locationAuth: '允许访问位置信息',
      contactAuth: '允许访问通讯录',
      cameraAuth: '允许访问相机',
      calendarAuth: '允许访问日历',
      phoneAuth: '允许访问电话',
      callAuth: '允许访问通话记录',
    },
  },
  {
    path: '/creditContracts/:token?/:signOrderId?',
    name: 'creditContracts',
    component: () => import('../pages/creditContracts.vue'),
    meta: {
      title: '合同',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
  },
  {
    path: '/cfcaAuth',
    name: 'cfcaAuth',
    component: () => import('../pages/cfcaAuth.vue'),
    meta: {
      title: '合同',
    },
  },
  {
    path: '/commonSingleContract',
    name: 'commonSingleContract',
    component: () => import('../pages/commonSingleContract.vue'),
    meta: {
      title: '合同',
    },
  },
  {
    path: '/channelCreditContracts',
    name: 'channelCreditContracts',
    component: () => import('../pages/channelCreditContracts.vue'),
    meta: {
      title: '合同',
    },
  },
  {
    path: '/channelCreditContract',
    name: 'channelCreditContract',
    component: () => import('../pages/channelCreditContract.vue'),
    meta: {
      title: '合同',
      pageSource: 'channel',
    },
  },
  {
    path: '/doudou/creditContract', // 豆豆对接导流平台
    name: 'doudouCreditContract',
    component: () => import('../pages/channelCreditContract.vue'),
    meta: {
      title: '合同',
      pageSource: 'doudou',
    },
  },
  {
    path: '/vbsContractList', // 正式合同列表
    name: 'vbsContractList',
    component: () => import('../../../pages/vbsContract/vbsContractList.vue'),
    meta: {
      title: '合同列表',
    },
  },
  {
    path: '/vbsContractDetail', // 正式合同详情
    name: 'vbsContractDetail',
    component: () => import('../../../pages/vbsContract/vbsContractDetail.vue'),
    meta: {
      title: '合同详情',
    },
  },
  {
    path: '/changeCardContract',
    name: 'changeCardContract',
    component: () => import('../pages/changeCardContract.vue'),
    meta: {
      title: '合同',
    },
  },
  {
    path: '/changeCardContractDetail',
    name: 'changeCardContractDetail',
    component: () => import('../pages/changeCardContractDetail.vue'),
    meta: {
      title: '合同详情',
    },
  },
  {
    path: '/channelChangeCardContract',
    name: 'channelChangeCardContract',
    component: () => import('../pages/channelChangeCardContract.vue'),
    meta: {
      title: '合同',
      pageSource: 'channel',
    },
  },
  {
    path: '/doudou/changeCardContract', // 豆豆对接导流平台
    name: 'doudouChangeCardContract',
    component: () => import('../pages/channelChangeCardContract.vue'),
    meta: {
      title: '合同',
      pageSource: 'doudou',
    },
  },
  {
    path: '/contractDetail',
    name: 'contractDetail',
    component: () => import('../../../components/contractDetail.vue'),
    meta: {
      title: '合同详情',
    },
  },
  {
    path: '/xwdContractList/:token/:typeList',
    name: 'xwdContractList',
    component: () => import('../pages/xwdContractList.vue'),
    meta: {
      title: '合同列表',
    },
  },
  {
    path: '/xwdContractDetail/:token',
    name: 'xwdContractDetail',
    component: () => import('../pages/xwdContractDetail.vue'),
    meta: {
      title: '合同详情',
    },
  },
  {
    path: '/pocketContractList/:token/:typeList',
    name: 'pocketContractList',
    component: () => import('../pages/pocketContractList.vue'),
    meta: {
      title: '合同列表',
    },
  },
  {
    path: '/pocketContractDetail/:token',
    name: 'pocketContractDetail',
    component: () => import('../pages/pocketContractDetail.vue'),
    meta: {
      title: '合同详情',
    },
  },
  // 注册协议
  {
    path: '/register/:type',
    name: 'register',
    component: () => import('../pages/register.vue'),
    meta: {
      title: '服务许可协议',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
  },
  {
    path: '/personAuth',
    name: 'personAuth',
    component: () => import('../pages/personAuth.vue'),
    meta: {
      title: '个人信息授权书',
    },
  },
  // 隐私政策
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../pages/privacy.vue'),
    meta: {
      title: '隐私政策',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
  },
  // 服务许可协议和隐私政策（客服人脸认证一键登录使用）
  {
    path: '/registerAndPrivacy',
    name: 'registerAndPrivacy',
    component: () => import('../pages/registerAndPrivacy.vue'),
    meta: {
      title: '服务许可协议、隐私政策',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
  },
  // 隐私政策简要版
  {
    path: '/privacyBrief',
    name: 'privacyBrief',
    component: () => import('../pages/privacyBrief.vue'),
    meta: {
      title: '隐私政策',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
  },
  {
    path: '/sdkList',
    name: 'sdkList',
    component: () => import('../pages/sdkList.vue'),
    meta: {
      title: '第三方SDK目录',
    },
  },
  {
    path: '/privacySence',
    name: 'privacySence',
    component: () => import('../pages/privacySence.vue'),
    meta: {
      title: 'APP设备权限目录',
    },
  },
  {
    path: '/permissionList',
    name: 'permissionList',
    component: () => import('../pages/permissionList.vue'),
    meta: {
      title: '应用权限说明',
    },
  },
  {
    path: '/sdkList',
    name: 'sdkList',
    component: () => import('../pages/sdkList.vue'),
    meta: {
      title: '第三方SDK目录',
    },
  },
  {
    path: '/educationAuth/authContract',
    name: 'educationAuthContract',
    component: () => import('../educationAuth/authContract.vue'),
    meta: {
      title: '学历图像信息认证授权协议',
    },
  },
  {
    path: '/authContract/faceAuthContract',
    name: 'faceAuthContract',
    component: () => import('../pages/faceAuthContract.vue'),
    meta: {
      title: '豆豆钱人脸识别授权书',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
  },
  {
    path: '/personInfoCollect',
    name: 'personInfoCollect',
    component: () => import('../pages/personal-info-collect.vue'),
    meta: {
      title: '个人信息收集说明',
    },
  },
  {
    path: '/personInfoShare',
    name: 'personInfoShare',
    component: () => import('../pages/personal-info-share.vue'),
    meta: {
      title: '个人信息共享说明',
    },
  },
  {
    path: '/oneKeyBindCardService',
    name: 'oneKeyBindCardService',
    component: () => import('../pages/oneKeyBindCardService.vue'),
    meta: {
      title: '一键绑卡用户服务协议',
      isUpload: true, // 用户截屏行为是否上传至后台落库
    },
  },
  {
    path: '/oneKeyBindCardDuXiaoManUser',
    name: 'oneKeyBindCardDuXiaoManUser',
    component: () => import('../pages/oneKeyBindCardDuXiaoManUser.vue'),
    meta: {
      title: '用户个人信息共享授权书',
      isUpload: true,
    },
  },
  {
    path: '/oneKeyBindCardDuXiaoManPay',
    name: 'oneKeyBindCardDuXiaoManPay',
    component: () => import('../pages/oneKeyBindCardDuXiaoManPay.vue'),
    meta: {
      title: '快捷支付服务协议',
      isUpload: true,
    },
  },
  {
    path: '/platformPersonInfo/:token',
    name: 'platform-personinfo',
    component: () => import('../pages/platformPersonInfo'),
    meta: {
      title: '个人信息共享授权书',
    },
  },
  {
    path: '/productService',
    name: 'productService',
    component: () => import('../pages/productService.vue'),
    meta: {
      title: '产品功能',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/contracts/',
  routes,
});
router.beforeEach((to, from, next) => {
  // 部分手机没有scroll方法
  document.getElementById('contractBody') && document.getElementById('contractBody').scroll && document.getElementById('contractBody').scroll(0, 0);
  const meta = to.meta || {};
  document.title = meta.title || meta[to.query.pageType] || '';
  EventBus.$emit('clearRequesting'); // 触发清除请求
  store.commit('setToken', to.params.token || '');
  store.commit('setAccessToken', to.query.accessToken || '');
  jsBridge.setWebpageSettingInfo({
    ...to.meta,
    isIntercept: true,
  });
  if (to.query.channel === jsBridge.APPChannelName && ['loanContract', 'xwdContractDetail', 'creditContracts'].includes(to.name) && !(store.state.token && !['token', 'signorderID', 'signOrderId'].includes(store.state.token))) { // app没有有效token
    jsBridge.getAppToken().then((appToken) => {
      store.commit('setToken', appToken);
      next();
    }).catch((err) => {
      next();
      console.err(err);
    });
  } else {
    next();
  }
});
export default router;
